import { LoadingDots } from "PFComponents/loading_dots";
import React, { JSX } from "react";

import { Report, ReportStatus } from "../../../types/reports";
import css from "../../reports.module.scss";
import { DeleteButton } from "./delete_button";
import { DownloadButton } from "./download_button";
import { MultiDownloadButton } from "./multi_download_button";
import { DownloadReportOption } from "./multi_download_button/multi_download_button";

type ActionColumnProps = {
  row: Report;
};

export const ActionColumn = ({ row }: ActionColumnProps): JSX.Element => {
  const { id, schedule, status, name, versions } = row;

  const multiDownloadOptions: DownloadReportOption[] = versions.map(({ createdAt, downloadUri }) => ({
    creationDate: new Date(createdAt),
    uri: downloadUri
  }));
  const isFinishedNotScheduledReport = !schedule && status === ReportStatus.Finished;

  return (
    <div className={css.action}>
      {schedule && <DeleteButton reportId={id} reportName={name} />}
      {
        <MultiDownloadButton
          options={multiDownloadOptions}
          disabled={!versions.some(({ downloadUri }) => !!downloadUri)}
        />
      }
      {isFinishedNotScheduledReport && <DownloadButton downloadUri={versions[0].downloadUri} />}
      {!schedule && (status === ReportStatus.InProgress || status === ReportStatus.Cancelled) && (
        <LoadingDots circlesEnabled circleSize="xs" />
      )}
    </div>
  );
};
